import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { MbConstants } from '../../../../shared/mb-constants'
import { Salutation } from '../../../../models'

@Component({
  selector: 'mb-checkout-salutation-form-partial',
  templateUrl: './mb-checkout-salutation-form-partial.component.html',
})
export class MbCheckoutSalutationFormPartialComponent {

  constants = MbConstants

  @Input() formGroup: UntypedFormGroup | undefined
  @Input() salutations: Salutation[] | undefined
  @Input() selectedSalutation: Salutation | undefined
  @Input() salutationLabelKey = 'contact.salutation'
  @Input() salutationOptional = true
  @Input() isFormDisabled = false

  onSalutationChange (value: Salutation) {
    this.selectedSalutation = value
    this.formGroup?.patchValue({ title: value })
  }
}
